<article class="plan-summary">
  <header class="plan-summary__header">
    <h3 class="plan-summary__header--plan typog-h4">Plan number</h3>
    <h3 class="plan-summary__header--status typog-h4">Plan status</h3>
  </header>

  <section class="plan-summary__section">
    <div class="plan-summary__content plan-summary__content--plan">
      <p
        [class.single]="!upsellEnabled && !offer?.outstanding_dd_amount"
        class="margin--none"
        [dgxQmSanitise]="'encrypt'"
      >
        {{ currentPlan?.plan_number }}
      </p>
    </div>
    <div class="plan-summary__content plan-summary__content--status">
      <p class="plan-summary__info margin--none">
        <span class="icon icon-info plan-info__icon icon--lg"
          ><span class="path1"></span><span class="path2"></span>
        </span>
        <span
          class="plan-summary__info--message"
          [class.single]="!upsellEnabled && !offer?.outstanding_dd_amount"
          [innerHTML]="message"
        ></span>
      </p>
    </div>
  </section>
</article>
